import { useContext, useState } from 'react';

import { observer } from 'mobx-react-lite';

import Button from 'components/common/Button/Button';
import SideBar from 'components/common/SideBar/SideBar';
import { RootStoreContext } from 'index';
import { PermissionName } from 'components/permissions/permissions.enum';
import { hasPermission } from 'components/permissions/permissions.utils';

import styles from './UsersManagement.module.scss';
import UsersTable from './UsersTable/UsersTable';
import UserProfileForm from './UserProfileForm/UserProfileForm';
import { UserProfileOpenMode } from '../users.enums';

const UsersManagement = () => {
  const { authStore } = useContext(RootStoreContext);
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);

  const canUserAdd = hasPermission(authStore.account!.permissions, [PermissionName.UserUpdate]);

  const handleAddUser = async () => {
    setIsSideBarOpen(true);
  };

  const handleClose = () => {
    setIsSideBarOpen(false);
  };

  return (
    <div className={styles.usersPage}>
      <div className={styles.infoContainer}>
        <div className={styles.headerTitle}>User Management</div>
        {canUserAdd && (
          <div>
            <Button className={styles.button} onClick={handleAddUser}>
              + Add User
            </Button>
            <SideBar title="User Setup" isOpen={isSideBarOpen} onClose={handleClose}>
              <UserProfileForm openMode={UserProfileOpenMode.Create} onClose={handleClose} />
            </SideBar>
          </div>
        )}
      </div>
      <div className={styles.tableContainer}>
        <UsersTable />
      </div>
    </div>
  );
};

export default observer(UsersManagement);
